import { render } from "./down-index.vue?vue&type=template&id=87cec2a6"
import script from "./down-index.vue?vue&type=script&lang=js"
export * from "./down-index.vue?vue&type=script&lang=js"

import exportComponent from "/Users/chenjun/Desktop/myProject/pbl-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__